import type { IssueGroup } from '@/lib/api/channel-readiness'
import type { ReadinessActionState } from '@/types/products'

export const KANBAN_STATES: ReadinessActionState[] = ['review_pending', 'action_required', 'in_progress', 'ready']

/** Merges IssueGroup arrays from multiple channels, summing product_count by issue_type|field|message key. */
export function mergeIssueGroups(
  allGroups: { channelId: string; groups: IssueGroup[] }[]
): IssueGroup[] {
  const map = new Map<string, IssueGroup>()
  for (const { groups } of allGroups) {
    for (const g of groups) {
      const key = `${g.issue_type}|${g.field}|${g.message}`
      const existing = map.get(key)
      if (existing) {
        existing.product_count += g.product_count
      } else {
        map.set(key, { ...g })
      }
    }
  }
  return Array.from(map.values())
}
